/**
 * Naming a dataset before it is built from the ticked scenarios. Building fills in each case's
 * reply and sources at once, then prepares each one for review by capturing its tools; the dataset
 * page shows that happening.
 */

import { DatasetDetailsDialog } from './dataset-details-dialog';

interface CreateDatasetDialogProps {
	open: boolean;
	/** The ticked scenarios; each becomes a case. */
	count: number;
	/** What the cases have in common, offered as the name. */
	suggestedName: string;
	/** How the dataset's Live data runs treat the fabricated scenarios among them, when there are any. */
	note?: string | null;
	creating: boolean;
	onOpenChange: (open: boolean) => void;
	onCreate: (name: string, description: string | null) => void;
}

export const CreateDatasetDialog = ({
	open,
	count,
	suggestedName,
	note,
	creating,
	onOpenChange,
	onCreate
}: CreateDatasetDialogProps) => (
	<DatasetDetailsDialog
		open={open}
		title='Create a dataset'
		description={
			<>
				{count === 1 ? 'The ticked scenario becomes a case' : `The ${count} ticked scenarios become cases`} for you to
				review, filled in with the agent&apos;s reply where there is one, the SOP and the tools the AI calls.
				{note && <span className='mt-1 block text-amber-700'>{note}</span>}
			</>
		}
		submitLabel='Create dataset'
		initialName={suggestedName}
		initialDescription={null}
		busy={creating}
		onOpenChange={onOpenChange}
		onSubmit={onCreate}
	/>
);
